import Api from '@/api/Api'
import BatchApi from '@/api/Batch'

class CodeApi extends Api {
  protected resource = 'codes'

  public async generateCodes<T>(batchId: number, quantity: number): Promise<T> {
    // Use BatchApi for code generation since codes are generated through batches
    return BatchApi.generateCode<T>(batchId, { quantity })
  }
}

export default new CodeApi()
